// components
import { InputSearch } from '../InputSearch';
import { PosCard } from './PosCard';
import { PaginationList } from '../PaginationList';
import { PosCardSkeleton } from './PosCardSkeleton';
import { NotResults } from '../NotResults';
// utils && hooks
import usePosList from './hooks/usePosList';
// styles
import styles from './PosList.module.css';

const PosList = () => {
    const {
        handleClearSearch,
        handleGetPointOfSale,
        searchValue,
        setSearchValue,
        data,
        perPage,
        isLoading,
        totalRows,
        currentPage,
        totalPages,
        isFirstFetch,
    } = usePosList();

    return (
        <>
            <InputSearch
                searchValue={searchValue}
                setSearchValue={setSearchValue}
                clearSearch={handleClearSearch}
                loading={isFirstFetch}
                width={608}
            />
            <div className={styles['wrapper']}>
                <div className={styles['pos-wrapper']}>
                    {isLoading ? (
                        Array.from({ length: 7 }).map((_, idx) => {
                            return <PosCardSkeleton key={idx + 1} />;
                        })
                    ) : data?.length > 0 ? (
                        data?.map((pos) => {
                            return <PosCard pos={pos} key={pos?.id} />;
                        })
                    ) : (
                        <NotResults />
                    )}
                </div>
                {data?.length > 0 && !isLoading && (
                    <div className={styles['wrapper-pagination']}>
                        <PaginationList
                            total={totalRows}
                            activePage={currentPage}
                            limit={perPage}
                            onChangePage={(new_page) => handleGetPointOfSale(perPage, new_page)}
                            onChangeLimit={(limit) => handleGetPointOfSale(limit, 1)}
                            pages={totalPages}
                            isLoading={isLoading}
                        />
                    </div>
                )}
            </div>
        </>
    );
};

export default PosList;
